// @ts-nocheck
import { DefaultRequestBody, MockedRequest, rest, RestHandler } from 'msw';
import { CreateWorksheetEntryRequest } from '../../queries/use-create-worksheet-entry';
import { UpdateWorksheetEntriesRequest } from '../../queries/use-update-worksheet-entries';
import { DeleteWorksheetEntriesRequest } from '../../queries/use-delete-worksheet-entries';
import { WorksheetChecklistItemStatusEnum } from '../../types/worksheet-checklist-item';
import { FileRecord, FileRecordTypeEnum } from '../../types/file-record';
import { ReconciliationWorksheet, WorksheetHistoryEventEnum, WorksheetStatusEnum } from '../../types/worksheet';
import { WorksheetEntry } from '../../types/worksheet-entry';
import { DB } from '../db';
import { ExcludeWorksheetsRequest } from '../../queries/use-exclude-worksheets';
import { IncludeWorksheetsRequest } from '../../queries/use-include-worksheets';
import { paginate } from '../utils';
import { ClientQueryStatusEnum } from '../../types/client-query';
import { InternalCommentStatusEnum } from '../../types/internal-comment';
import { UpdateWorksheetsRequest } from '../../queries/use-update-worksheets';
import { NatureEnum } from '../../types/nature';

const routes: RestHandler<MockedRequest<DefaultRequestBody>>[] = [];

routes.push(
    /**
     * GET /worksheets
     * Gets all worksheet overviews belonging to a workpaper
     */
    rest.get('/workpapers/:id/worksheets', (req, res, ctx) => {
        const page = parseInt(req.url.searchParams.get('page') || '1');
        const limit = parseInt(req.url.searchParams.get('limit') || '10');
        const search = req.url.searchParams.get('search');
        const sort = req.url.searchParams.get('sort');
        const filter = req.url.searchParams.get('filter');
        console.log(filter);
        let worksheets = DB.GetWorksheets();
        let totalRows = worksheets.length;

        if (search) {
            worksheets = worksheets.filter((ws) => {
                const _search = search.toLowerCase();
                const found =
                    ws.name.toLowerCase().includes(_search) ||
                    ws.type.toLowerCase().includes(_search) ||
                    ws.account?.reportCode.toLowerCase().includes(_search);
                return found;
            });
            totalRows = worksheets.length;
        } else if (filter) {
            const filterObj = JSON.parse(decodeURIComponent(filter));
            if (filterObj.status) {
                const value = filterObj.status;
                worksheets = worksheets.filter((ws) => value.includes(ws.status));
            }
            if (filterObj.class) {
                const value = filterObj.class;
                worksheets = worksheets.filter((ws) => value.includes(ws.class));
            }
            if (filterObj.currentAmount) {
                const { base, condition, to } = filterObj.currentAmount;
                if (condition === '>') {
                    worksheets = worksheets.filter((ws) =>
                        ws.workpaperCreditTY
                            ? ws.workpaperCreditTY > base * 100
                            : ws.workpaperDebitTY
                            ? ws.workpaperDebitTY > base * 100
                            : undefined
                    );
                } else if (condition === '=') {
                    worksheets = worksheets.filter((ws) =>
                        ws.workpaperCreditTY
                            ? ws.workpaperCreditTY === base * 100
                            : ws.workpaperDebitTY
                            ? ws.workpaperDebitTY === base * 100
                            : undefined
                    );
                } else if (condition === '<') {
                    worksheets = worksheets.filter((ws) =>
                        ws.workpaperCreditTY
                            ? ws.workpaperCreditTY < base * 100
                            : ws.workpaperDebitTY
                            ? ws.workpaperDebitTY < base * 100
                            : undefined
                    );
                } else {
                    worksheets = worksheets.filter((ws) =>
                        ws.workpaperCreditTY
                            ? ws.workpaperCreditTY >= base * 100 && ws.workpaperCreditTY <= to * 100
                            : ws.workpaperDebitTY
                            ? ws.workpaperDebitTY >= base * 100 && ws.workpaperDebitTY <= to * 100
                            : undefined
                    );
                }
            }
            if (filterObj.amountLY) {
                const { base, condition, to } = filterObj.amountLY;
                if (condition === '>') {
                    worksheets = worksheets.filter((ws) =>
                        ws.ledgerCreditLY ? ws.ledgerCreditLY > base * 100 : ws.ledgerDebitLY ? ws.ledgerDebitLY > base * 100 : undefined
                    );
                } else if (condition === '=') {
                    worksheets = worksheets.filter((ws) =>
                        ws.ledgerCreditLY
                            ? ws.ledgerCreditLY === base * 100
                            : ws.ledgerDebitLY
                            ? ws.ledgerDebitLY === base * 100
                            : undefined
                    );
                } else if (condition === '<') {
                    worksheets = worksheets.filter((ws) =>
                        ws.ledgerCreditLY ? ws.ledgerCreditLY < base * 100 : ws.ledgerDebitLY ? ws.ledgerDebitLY < base * 100 : undefined
                    );
                } else {
                    worksheets = worksheets.filter((ws) =>
                        ws.ledgerCreditLY
                            ? ws.ledgerCreditLY >= base * 100 && ws.ledgerCreditLY <= to * 100
                            : ws.ledgerDebitLY
                            ? ws.ledgerDebitLY >= base * 100 && ws.ledgerDebitLY <= to * 100
                            : undefined
                    );
                }
            }
            if (filterObj.variance) {
                const { base, condition, to } = filterObj.variance;
                if (condition === '>') {
                    worksheets = worksheets.filter((ws) => Math.abs(ws.variancePercent) > base);
                } else if (condition === '=') {
                    worksheets = worksheets.filter((ws) => Math.abs(ws.variancePercent) === base);
                } else if (condition === '<') {
                    worksheets = worksheets.filter((ws) => Math.abs(ws.variancePercent) < base);
                } else {
                    worksheets = worksheets.filter((ws) => Math.abs(ws.variancePercent) >= base && Math.abs(ws.variancePercent) <= to);
                }
            }
            if (filterObj.outstandingQueries) {
                const { base, condition, to } = filterObj.outstandingQueries;
                if (condition === '>') {
                    worksheets = worksheets.filter(
                        (ws) => ws.clientQueries.filter((cq) => cq.status === ClientQueryStatusEnum.ACTIVE).length > base
                    );
                } else if (condition === '=') {
                    worksheets = worksheets.filter(
                        (ws) => ws.clientQueries.filter((cq) => cq.status === ClientQueryStatusEnum.ACTIVE).length === base
                    );
                } else if (condition === '<') {
                    worksheets = worksheets.filter(
                        (ws) => ws.clientQueries.filter((cq) => cq.status === ClientQueryStatusEnum.ACTIVE).length < base
                    );
                } else {
                    worksheets = worksheets.filter(
                        (ws) =>
                            ws.clientQueries.filter((cq) => cq.status === ClientQueryStatusEnum.ACTIVE).length >= base &&
                            ws.clientQueries.filter((cq) => cq.status === ClientQueryStatusEnum.ACTIVE).length <= to
                    );
                }
            }
            if (filterObj.outstandingComments) {
                const { base, condition, to } = filterObj.outstandingComments;

                if (condition === '>') {
                    worksheets = worksheets.filter(
                        (ws) => ws.internalComments.filter((ic) => ic.status === InternalCommentStatusEnum.ACTIVE).length > base
                    );
                } else if (condition === '=') {
                    worksheets = worksheets.filter(
                        (ws) => ws.internalComments.filter((ic) => ic.status === InternalCommentStatusEnum.ACTIVE).length === base
                    );
                } else if (condition === '<') {
                    worksheets = worksheets.filter(
                        (ws) => ws.internalComments.filter((ic) => ic.status === InternalCommentStatusEnum.ACTIVE).length < base
                    );
                } else {
                    worksheets = worksheets.filter(
                        (ws) =>
                            ws.internalComments.filter((ic) => ic.status === InternalCommentStatusEnum.ACTIVE).length >= base &&
                            ws.internalComments.filter((ic) => ic.status === InternalCommentStatusEnum.ACTIVE).length <= to
                    );
                }
            }
            if (filterObj.assigned) {
                const value = filterObj.assigned;
                worksheets = worksheets.filter((ws) => ws.assigned.some((assignee) => value.includes(assignee.id)));
            }
            totalRows = worksheets.length;
        }

        if (sort) {
            const { order, option } = JSON.parse(decodeURIComponent(sort));
            console.log({ order, option });

            if (option === 'code') {
                worksheets = worksheets.sort((a, b) => (a.code > b.code ? 1 : -1));
            } else if (option === 'description') {
                worksheets = worksheets.sort((a, b) => (a.description.toLowerCase() > b.description.toLowerCase() ? 1 : -1));
            } else if (option === 'status') {
                worksheets = worksheets.sort((a, b) => (a.status.toLowerCase() > b.status.toLowerCase() ? 1 : -1));
            } else if (option === 'currentAmount') {
                worksheets.sort((a, b) => {
                    const valueA = a.ledgerDebitTY || a.ledgerCreditTY || 0;
                    const valueB = b.ledgerDebitTY || b.ledgerCreditTY || 0;
                    return valueA > valueB ? 1 : -1;
                });
            } else if (option === 'lastYearAmount') {
                worksheets.sort((a, b) => {
                    const valueA = a.ledgerDebitLY || a.ledgerCreditLY || 0;
                    const valueB = b.ledgerDebitLY || b.ledgerCreditLY || 0;
                    return valueA > valueB ? 1 : -1;
                });
            } else if (option === 'variance') {
                worksheets = worksheets.sort((a, b) => (Math.abs(a.variancePercent) > Math.abs(b.variancePercent) ? 1 : -1));
            } else if (option === 'activeClientQueries') {
                worksheets = worksheets.sort((a, b) => (a.clientQueries.length > b.clientQueries.length ? 1 : -1));
            } else if (option === 'activeInternalComments') {
                worksheets = worksheets.sort((a, b) => (a.internalComments.length > b.internalComments.length ? 1 : -1));
            } else if (option === 'reportCode') {
                worksheets = worksheets.sort((a, b) => (a.reportCode > b.reportCode ? 1 : -1));
            } else if (option === 'accountType') {
                worksheets = worksheets.sort((a, b) => (a.type > b.type ? 1 : -1));
            }
            if (order === 'desc') {
                worksheets = worksheets.reverse();
            }
        }

        return res(
            ctx.delay(),
            ctx.status(200),
            ctx.json({ worksheets: paginate<ReconciliationWorksheet>(worksheets, page, limit), totalItems: totalRows })
        );
    }),

    /**
     * PATCH /worksheets
     * Updates worksheets in bulk
     */
    rest.patch<UpdateWorksheetsRequest>('/workpapers/:id/worksheets', (req, res, ctx) => {
        const body = req.body;

        for (const req of body) {
            if (req.fields.assigned) {
                DB.UpdateWorksheetAssignees(req.id, req.fields.assigned);
            }
        }
        return res(ctx.delay(), ctx.status(200));
    }),

    /**
     * POST /worksheets/exclude
     * Excludes worksheets
     */
    rest.post<ExcludeWorksheetsRequest>('/workpapers/:id/worksheets/exclude', (req, res, ctx) => {
        req.body.forEach(({ id }) => {
            DB.AddWorksheetHistoryEvent(WorksheetHistoryEventEnum.STATUS_CHANGE, 'Worksheet excluded', id);
            DB.CalculateWorksheetStatus(id, WorksheetStatusEnum.EXCLUDED);
        });
        return res(ctx.delay(), ctx.status(200));
    }),

    /**
     * POST /worksheets/include
     * Includes excluded worksheets
     */
    rest.post<IncludeWorksheetsRequest>('/workpapers/:id/worksheets/include', (req, res, ctx) => {
        req.body.forEach(({ id }) => {
            DB.AddWorksheetHistoryEvent(WorksheetHistoryEventEnum.STATUS_CHANGE, 'Worksheet included', id);
            DB.CalculateWorksheetStatus(id);
        });
        return res(ctx.delay(), ctx.status(200));
    }),

    /**
     * POST /worksheets/:id/review
     * Reviews an applicable worksheet
     */
    rest.post('/workpapers/:id/worksheets/:id/review', (req, res, ctx) => {
        const id = req.params.id as string;

        const worksheet = DB.GetWorksheet(id) as ReconciliationWorksheet;
        if (worksheet.status === WorksheetStatusEnum.AWAITING_REVIEW) {
            DB.AddWorksheetHistoryEvent(WorksheetHistoryEventEnum.STATUS_CHANGE, 'Worksheet reviewed', id);

            DB.CalculateWorksheetStatus(id, WorksheetStatusEnum.REVIEWED);
        }

        return res(ctx.delay(), ctx.status(200));
    }),

    /**
     * GET /worksheets/:id
     * Gets a worksheet with the specified id
     */
    rest.get('/workpapers/:id/worksheets/:id', (req, res, ctx) => {
        const id = req.params.id as string;
        const worksheet = DB.GetWorksheet(id);
        return res(ctx.delay(), ctx.status(worksheet ? 200 : 404), ctx.json({ worksheet }));
    }),

    /**
     * GET /worksheets/:id/cycle
     * Gets the next and previous worksheet
     */
    rest.get('/workpapers/:id/worksheets/:id/cycle', (req, res, ctx) => {
        const id = req.params.id as string;
        const sort = req.url.searchParams.get('sort');
        const filter = req.url.searchParams.get('filter');

        const worksheets = DB.GetWorksheets();

        const results = filterWorksheets(worksheets, null, filter, sort);

        let prev: ReconciliationWorksheet | undefined;
        let next: ReconciliationWorksheet | undefined;

        let notFound = true;

        for (let i = 0; i < results.worksheets.length; i++) {
            if (results.worksheets[i].id === id) {
                if (i === 0) {
                    next = results.worksheets[i + 1];
                } else if (i === worksheets.length - 1) {
                    prev = results.worksheets[i - 1];
                } else {
                    next = results.worksheets[i + 1];
                    prev = results.worksheets[i - 1];
                }
                notFound = false;
                break;
            }
        }

        // Safe guard
        if (notFound) {
            prev = results.worksheets[0];
            next = results.worksheets[1];
        }

        return res(
            ctx.delay(),
            ctx.status(200),
            ctx.json({
                next: next ? { id: next.id, code: next.code, description: next.description } : undefined,
                prev: prev ? { id: prev.id, code: prev.code, description: prev.description } : undefined,
            })
        );
    }),

    /**
     * GET /worksheets/:id/checklist
     * Gets the checklist for a worksheet with the specified id
     */
    rest.get('/workpapers/:id/worksheets/:id/checklist', (req, res, ctx) => {
        const id = req.params.id as string;

        const checklist = DB.GetWorksheetChecklist(id);

        return res(ctx.delay(), ctx.status(200), ctx.json({ data: checklist, totalItems: checklist.length }));
    }),

    /**
     * PATCH /worksheets/:id/checklist
     * Updates a checklist item status for the specified worksheet
     */
    rest.patch<{ checklistItemId: string; status: WorksheetChecklistItemStatusEnum }>(
        '/workpapers/:id/worksheets/:worksheetId/checklist/:id',
        (req, res, ctx) => {
            const worksheetId = req.params.worksheetId as string;
            const id = req.params.id as string;
            const { status } = req.body;

            const worksheet = DB.GetWorksheet(worksheetId) as ReconciliationWorksheet;

            DB.UpdateWorksheetChecklistItemStatus(worksheetId, id, status);

            if (status === WorksheetChecklistItemStatusEnum.CHECKED) {
                DB.AddWorksheetHistoryEvent(
                    WorksheetHistoryEventEnum.CHECKLIST_ITEM_CHECK,
                    'Checklist item changed to checked',
                    worksheet.id
                );
            }

            if (status === WorksheetChecklistItemStatusEnum.UNCHECKED) {
                DB.AddWorksheetHistoryEvent(
                    WorksheetHistoryEventEnum.CHECKLIST_ITEM_UNCHECK,
                    'Checklist item changed to unchecked',
                    worksheet.id
                );
            }

            if (status === WorksheetChecklistItemStatusEnum.NOT_APPLICABLE) {
                DB.AddWorksheetHistoryEvent(
                    WorksheetHistoryEventEnum.CHECKLIST_ITEM_NOT_APPLICABLE,
                    'Checklist item changed to applicable',
                    worksheet.id
                );
            }

            setTimeout(() => {
                DB.CalculateWorksheetStatus(id);
            }, 1);

            return res(ctx.delay(), ctx.status(200), ctx.json({}));
        }
    ),

    /**
     * GET /worksheets/:id/entries
     * Get all entries for a worksheet
     */
    rest.get('/workpapers/:id/worksheets/:id/entries', (req, res, ctx) => {
        const worksheetId = req.params.id as string;
        const entries = DB.GetWorksheetEntries(worksheetId);

        return res(ctx.delay(), ctx.status(200), ctx.json({ data: entries, totalItems: entries.length }));
    }),

    /**
     * GET /worksheets/:id/history
     * Gets the history for a worksheet
     */
    rest.get('/workpapers/:id/worksheets/:id/history', (req, res, ctx) => {
        const history = DB.GetWorksheetHistory(req.params.id as string);
        return res(ctx.delay(), ctx.status(200), ctx.json({ data: history, totalItems: history.length }));
    }),

    rest.post<CreateWorksheetEntryRequest>('/workpapers/:id/worksheets/:id/entries', (req, res, ctx) => {
        const worksheetId = req.params.id as string;
        const { entry: entryReq } = req.body;

        const entry = DB.CreateWorksheetEntry(worksheetId, entryReq);
        DB.UpdateWorksheetVariance(worksheetId);

        // Get the worksheet
        const worksheet = DB.GetWorksheet(entry.worksheetId) as ReconciliationWorksheet;
        const filesIds: string[] = [];
        if (entryReq.files) {
            for (const id of entryReq.files) {
                const fileRecord = DB.GetFileRecord(id) as FileRecord;

                if (fileRecord.parentFolderId![0] === worksheet.id) {
                    filesIds.push(fileRecord.id);
                    continue;
                }

                if (fileRecord.recordType === FileRecordTypeEnum.DOCUMENT || fileRecord.recordType === FileRecordTypeEnum.LINK) {
                    const { id } = DB.CreateReferenceRecord(
                        DB.EnsureUniqueFileRecordName(fileRecord.name, worksheet.id),
                        fileRecord.id,
                        worksheet.id
                    );
                    filesIds.push(id);
                } else if (fileRecord.recordType === FileRecordTypeEnum.REFERENCE) {
                    const sourceFile = DB.GetFileRecord(fileRecord.source!.id) as FileRecord;
                    const { id } = DB.CreateReferenceRecord(
                        DB.EnsureUniqueFileRecordName(sourceFile.name, worksheet.id),
                        sourceFile.id,
                        worksheet.id
                    );
                    filesIds.push(id);
                }
            }

            DB.UpdateWorksheetEntry(entry.id, { files: filesIds });
        }

        let amount = new Intl.NumberFormat(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(entry.amount / 100);

        if (entry.nature === NatureEnum.CREDIT) {
            amount = `(${amount})`;
        }

        DB.AddWorksheetHistoryEvent(
            WorksheetHistoryEventEnum.ENTRY_CREATE,
            `Entry ENT#${entry.reference.toString().padStart(3, '0')} for ${amount} added`,
            worksheet.id
        );

        if (worksheet.status === WorksheetStatusEnum.REVIEWED) {
            DB.CalculateWorksheetStatus(worksheetId, WorksheetStatusEnum.AWAITING_REVIEW);
        }
        DB.CalculateWorksheetStatus(worksheetId);

        return res(ctx.delay(), ctx.status(200), ctx.json({}));
    }),

    rest.patch<UpdateWorksheetEntriesRequest>('/workpapers/:id/worksheets/:id/entries', (req, res, ctx) => {
        const worksheetId = req.params.id as string;
        const entriesReq = req.body;

        // Update files
        for (const req of entriesReq) {
            const entry = DB.GetWorksheetEntries(worksheetId).find((e) => e.id === req.id) as WorksheetEntry;
            // Get the worksheet
            const worksheet = DB.GetWorksheet(entry.worksheetId) as ReconciliationWorksheet;
            const filesIds: string[] = [];
            if (req.fields.files) {
                for (const id of req.fields.files) {
                    const fileRecord = DB.GetFileRecord(id) as FileRecord;

                    if (fileRecord.parentFolderId![0] === worksheet.id) {
                        filesIds.push(fileRecord.id);
                        continue;
                    }

                    if (fileRecord.recordType === FileRecordTypeEnum.DOCUMENT || fileRecord.recordType === FileRecordTypeEnum.LINK) {
                        const { id } = DB.CreateReferenceRecord(
                            DB.EnsureUniqueFileRecordName(fileRecord.name, worksheet.id),
                            fileRecord.id,
                            worksheet.id
                        );
                        filesIds.push(id);
                    } else if (fileRecord.recordType === FileRecordTypeEnum.REFERENCE) {
                        const sourceFile = DB.GetFileRecord(fileRecord.source!.id) as FileRecord;
                        const { id } = DB.CreateReferenceRecord(
                            DB.EnsureUniqueFileRecordName(sourceFile.name, worksheet.id),
                            sourceFile.id,
                            worksheet.id
                        );
                        filesIds.push(id);
                    }
                }
            }

            DB.UpdateWorksheetEntry(entry.id, { ...req.fields, files: filesIds });

            DB.AddWorksheetHistoryEvent(
                WorksheetHistoryEventEnum.ENTRY_UPDATE,
                `Entry ENT#${entry.reference.toString().padStart(3, '0')} edited`,
                worksheet.id
            );

            if (req.fields.amount !== undefined && req.fields.amount !== entry.amount) {
                let amount = new Intl.NumberFormat(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }).format(entry.amount / 100);

                if (entry.nature === NatureEnum.CREDIT) {
                    amount = `(${amount})`;
                }
            }

            // Files changed
            if (req.fields.files?.length !== entry.files.length || !entry.files.every((f) => req.fields.files?.includes(f))) {
                DB.AddWorksheetHistoryEvent(
                    WorksheetHistoryEventEnum.ENTRY_ATTACHMENT_UPDATE,
                    `Entry ENT#${entry.reference.toString().padStart(3, '0')} attached files changed`,
                    worksheet.id
                );
            }
            DB.UpdateWorksheetVariance(worksheetId);

            if (worksheet.status === WorksheetStatusEnum.REVIEWED) {
                DB.CalculateWorksheetStatus(worksheetId, WorksheetStatusEnum.AWAITING_REVIEW);
            }

            DB.CalculateWorksheetStatus(worksheetId);
        }
        return res(ctx.delay(), ctx.status(200), ctx.json({}));
    }),

    rest.delete<DeleteWorksheetEntriesRequest>('/workpapers/:id/worksheets/:id/entries', (req, res, ctx) => {
        const worksheetId = req.params.id as string;
        const { ids } = req.body;

        for (const id of ids) {
            const entry = DB.GetWorksheetEntries(worksheetId).find((e) => e.id === id) as WorksheetEntry;
            DB.DeleteWorksheetEntry(id);
            DB.AddWorksheetHistoryEvent(
                WorksheetHistoryEventEnum.ENTRY_DELETE,
                `Entry ENT#${entry.reference.toString().padStart(3, '0')} deleted`,
                worksheetId
            );
        }

        DB.UpdateWorksheetVariance(worksheetId);
        DB.CalculateWorksheetStatus(worksheetId);

        return res(ctx.delay(), ctx.status(200), ctx.json({}));
    })
);

function filterWorksheets(initalWorksheets: ReconciliationWorksheet[], search: string | null, filter: string | null, sort: string | null) {
    let totalRows = initalWorksheets.length;
    let worksheets = initalWorksheets;
    if (search) {
        worksheets = worksheets.filter((ws) => {
            const _search = search.toLowerCase();
            const found =
                ws.description.toLowerCase().includes(_search) ||
                ws.code.toLowerCase().includes(_search) ||
                ws.type.toLowerCase().includes(_search) ||
                ws.reportCode.toLowerCase().includes(_search);
            return found;
        });
        totalRows = worksheets.length;
    } else if (filter) {
        const filterObj = JSON.parse(decodeURIComponent(filter));
        if (filterObj.status) {
            const value = filterObj.status;
            worksheets = worksheets.filter((ws) => value.includes(ws.status));
        }
        if (filterObj.class) {
            const value = filterObj.class;
            worksheets = worksheets.filter((ws) => value.includes(ws.class));
        }
        if (filterObj.currentAmount) {
            const { base, condition, to } = filterObj.currentAmount;
            if (condition === '>') {
                worksheets = worksheets.filter((ws) =>
                    ws.ledgerCreditTY ? ws.ledgerCreditTY > base * 100 : ws.ledgerDebitTY ? ws.ledgerDebitTY > base * 100 : undefined
                );
            } else if (condition === '=') {
                worksheets = worksheets.filter((ws) =>
                    ws.ledgerCreditTY ? ws.ledgerCreditTY === base * 100 : ws.ledgerDebitTY ? ws.ledgerDebitTY === base * 100 : undefined
                );
            } else if (condition === '<') {
                worksheets = worksheets.filter((ws) =>
                    ws.ledgerCreditTY ? ws.ledgerCreditTY < base * 100 : ws.ledgerDebitTY ? ws.ledgerDebitTY < base * 100 : undefined
                );
            } else {
                worksheets = worksheets.filter((ws) =>
                    ws.ledgerCreditTY
                        ? ws.ledgerCreditTY >= base * 100 && ws.ledgerCreditTY <= to * 100
                        : ws.ledgerDebitTY
                        ? ws.ledgerDebitTY >= base * 100 && ws.ledgerDebitTY <= to * 100
                        : undefined
                );
            }
        }
        if (filterObj.amountLY) {
            const { base, condition, to } = filterObj.amountLY;
            if (condition === '>') {
                worksheets = worksheets.filter((ws) =>
                    ws.ledgerCreditLY ? ws.ledgerCreditLY > base * 100 : ws.ledgerDebitLY ? ws.ledgerDebitLY > base * 100 : undefined
                );
            } else if (condition === '=') {
                worksheets = worksheets.filter((ws) =>
                    ws.ledgerCreditLY ? ws.ledgerCreditLY === base * 100 : ws.ledgerDebitLY ? ws.ledgerDebitLY === base * 100 : undefined
                );
            } else if (condition === '<') {
                worksheets = worksheets.filter((ws) =>
                    ws.ledgerCreditLY ? ws.ledgerCreditLY < base * 100 : ws.ledgerDebitLY ? ws.ledgerDebitLY < base * 100 : undefined
                );
            } else {
                worksheets = worksheets.filter((ws) =>
                    ws.ledgerCreditLY
                        ? ws.ledgerCreditLY >= base * 100 && ws.ledgerCreditLY <= to * 100
                        : ws.ledgerDebitLY
                        ? ws.ledgerDebitLY >= base * 100 && ws.ledgerDebitLY <= to * 100
                        : undefined
                );
            }
        }
        if (filterObj.variance) {
            const { base, condition, to } = filterObj.variance;
            if (condition === '>') {
                worksheets = worksheets.filter((ws) => Math.abs(ws.variancePercent) > base);
            } else if (condition === '=') {
                worksheets = worksheets.filter((ws) => Math.abs(ws.variancePercent) === base);
            } else if (condition === '<') {
                worksheets = worksheets.filter((ws) => Math.abs(ws.variancePercent) < base);
            } else {
                worksheets = worksheets.filter((ws) => Math.abs(ws.variancePercent) >= base && Math.abs(ws.variancePercent) <= to);
            }
        }
        if (filterObj.outstandingQueries) {
            const { base, condition, to } = filterObj.outstandingQueries;
            if (condition === '>') {
                worksheets = worksheets.filter(
                    (ws) => ws.clientQueries.filter((cq) => cq.status === ClientQueryStatusEnum.ACTIVE).length > base
                );
            } else if (condition === '=') {
                worksheets = worksheets.filter(
                    (ws) => ws.clientQueries.filter((cq) => cq.status === ClientQueryStatusEnum.ACTIVE).length === base
                );
            } else if (condition === '<') {
                worksheets = worksheets.filter(
                    (ws) => ws.clientQueries.filter((cq) => cq.status === ClientQueryStatusEnum.ACTIVE).length < base
                );
            } else {
                worksheets = worksheets.filter(
                    (ws) =>
                        ws.clientQueries.filter((cq) => cq.status === ClientQueryStatusEnum.ACTIVE).length >= base &&
                        ws.clientQueries.filter((cq) => cq.status === ClientQueryStatusEnum.ACTIVE).length <= to
                );
            }
        }
        if (filterObj.outstandingComments) {
            const { base, condition, to } = filterObj.outstandingComments;
            if (condition === '>') {
                worksheets = worksheets.filter(
                    (ws) => ws.internalComments.filter((ic) => ic.status === InternalCommentStatusEnum.ACTIVE).length > base
                );
            } else if (condition === '=') {
                worksheets = worksheets.filter(
                    (ws) => ws.internalComments.filter((ic) => ic.status === InternalCommentStatusEnum.ACTIVE).length === base
                );
            } else if (condition === '<') {
                worksheets = worksheets.filter(
                    (ws) => ws.internalComments.filter((ic) => ic.status === InternalCommentStatusEnum.ACTIVE).length < base
                );
            } else {
                worksheets = worksheets.filter(
                    (ws) =>
                        ws.internalComments.filter((ic) => ic.status === InternalCommentStatusEnum.ACTIVE).length >= base &&
                        ws.internalComments.filter((ic) => ic.status === InternalCommentStatusEnum.ACTIVE).length <= to
                );
            }
        }
        if (filterObj.assigned) {
            const value = filterObj.assigned;
            worksheets = worksheets.filter((ws) => ws.assigned.some((assignee) => value.includes(assignee.id)));
        }
        totalRows = worksheets.length;
    }

    if (sort) {
        const { order, option } = JSON.parse(decodeURIComponent(sort));

        if (option === 'Code') {
            worksheets = worksheets.sort((a, b) => (a.code > b.code ? 1 : -1));
        } else if (option === 'Description') {
            worksheets = worksheets.sort((a, b) => (a.description.toLowerCase() > b.description.toLowerCase() ? 1 : -1));
        } else if (option === 'Status') {
            worksheets = worksheets.sort((a, b) => (a.status.toLowerCase() > b.status.toLowerCase() ? 1 : -1));
        } else if (option === 'Current Amount') {
            worksheets.sort((a, b) => {
                const valueA = a.ledgerDebitTY || a.ledgerCreditTY || 0;
                const valueB = b.ledgerDebitTY || b.ledgerCreditTY || 0;
                return valueA > valueB ? 1 : -1;
            });
        } else if (option === 'Amount LY') {
            worksheets.sort((a, b) => {
                const valueA = a.ledgerDebitLY || a.ledgerCreditLY || 0;
                const valueB = b.ledgerDebitLY || b.ledgerCreditLY || 0;
                return valueA > valueB ? 1 : -1;
            });
        } else if (option === 'Variance') {
            worksheets = worksheets.sort((a, b) => (Math.abs(a.variancePercent) > Math.abs(b.variancePercent) ? 1 : -1));
        } else if (option === 'Outstanding Queries') {
            worksheets = worksheets.sort((a, b) =>
                a.clientQueries.length + a.internalComments.length > b.clientQueries.length + b.internalComments.length ? 1 : -1
            );
        } else if (option === 'Report Code') {
            worksheets = worksheets.sort((a, b) => (a.reportCode > b.reportCode ? 1 : -1));
        } else if (option === 'Account Type') {
            worksheets = worksheets.sort((a, b) => (a.type > b.type ? 1 : -1));
        }
        if (order === 'desc') {
            worksheets = worksheets.reverse();
        }
    }
    return { worksheets, totalRows };
}

export { routes };
